// extracted by mini-css-extract-plugin
export var avatarContainer = "_5j-1";
export var largeAvatarContainer = "_5j-2";
export var smallAvatarContainer = "_5j-0";